// src/features/dashboard/services/Employee/monthlyProductivity.service.ts

import apiClient from '../../../../api/apiService';

import {
  ENDPOINTS,
} from '../../../../api/endpoints';

import type {
  MonthlyProductivityApiResponse,
  MonthlyProductivityRequest,
} from '../../types/Employee/monthlyProductivity.types';

export const getMonthlyProductivity = async (
  payload: MonthlyProductivityRequest,
): Promise<MonthlyProductivityApiResponse> => {

  const response = await apiClient.post(
    ENDPOINTS.EMPLOYEE_MONTHLY_AVG_PRODUCTIVITY,
    payload,
  );

  return response.data;
};